import {
  ensureBoolean,
  ensureNumber,
  ensureObject,
  ensureString,
} from "../../validate";
import { fetchJson } from "./http";
import {
  COURSES_BASE_URL,
  CoursesApiError,
  type SignupParams,
  type SignupResult,
} from "./types";

const FN = "GZIntegracoes.v1.cursos.signup";

/**
 * Matricula o usuário (grava no banco se ainda não existir) e sincroniza com o
 * SalesForce no backend. Devolve o JWT de acesso.
 *
 * Exige `token` anti-bot (reCAPTCHA v3 ou JWT) — a página que consome a lib é
 * responsável por obtê-lo. Sem token válido a API responde 403, que aqui vira
 * `CoursesApiError`.
 */
export async function signup(params: SignupParams): Promise<SignupResult> {
  ensureObject(params, `${FN}(params)`);
  ensureString(params.email, `${FN} → params.email`);
  ensureString(params.className, `${FN} → params.className`);
  ensureString(params.courseName, `${FN} → params.courseName`);
  ensureString(params.token, `${FN} → params.token`);

  if (params.newsletter !== undefined) {
    ensureObject(params.newsletter, `${FN} → params.newsletter`);
    ensureNumber(params.newsletter.pubListId, `${FN} → params.newsletter.pubListId`);
    ensureBoolean(params.newsletter.receber, `${FN} → params.newsletter.receber`);
    ensureString(params.newsletter.code, `${FN} → params.newsletter.code`);
  }

  const nl = params.newsletter;
  const newsletterFields = nl
    ? {
        newsletter: nl.code,
        newsletter_pub_list_id: nl.pubListId,
        newsletter_receber: nl.receber,
      }
    : {};

  const { status, ok, body } = await fetchJson(
    `${COURSES_BASE_URL}/signup?token=true`,
    {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        email: params.email,
        className: params.className,
        courseName: params.courseName,
        token: params.token,
        ...newsletterFields,
      }),
    },
  );

  if (!ok) {
    throw new CoursesApiError(
      `${FN}: resposta inesperada da API (status ${status}).`,
      status,
      body,
    );
  }

  const data = (body ?? {}) as {
    signup?: boolean;
    has_register?: boolean;
    token?: string;
    salesforce?: unknown;
  };

  return {
    signup: data.signup === true,
    hasRegister: data.has_register === true,
    token: data.token,
    salesforce: data.salesforce,
  };
}
